// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-bc30da68],\n.fade-leave-active[data-v-bc30da68],\n.fade-collapse-enter-active[data-v-bc30da68],\n.fade-collapse-leave-active[data-v-bc30da68] {\n\ttransition: opacity var(--animation-quick), max-height var(--animation-quick);\n}\n.fade-collapse-enter[data-v-bc30da68],\n.fade-collapse-leave-to[data-v-bc30da68] {\n\topacity: 0;\n\tmax-height: 0;\n}\n.fade-enter[data-v-bc30da68],\n.fade-leave-to[data-v-bc30da68] {\n\topacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
